import React from "react";

/**
 * When viewing customer details in an overlay (e.g. from Admin Tickets),
 * this context provides the customer id so tab content (ViewAddresses, ViewAssets, etc.)
 * can work without being under a route with :id.
 */
export const CustomerIdContext = React.createContext<number | null>(null);

export function useCustomerId(): string | undefined {
  const contextId = React.useContext(CustomerIdContext);
  return contextId != null ? String(contextId) : undefined;
}
